import * as React from 'react';
import { Box } from '@material-ui/core';
import CallSplitIcon from '@material-ui/icons/CallSplit';
import { PageContentLayout } from '../v2/layouts/PageContentLayout';
import { RouterProps } from '../App';
import { WizardFrame } from './WizardFrame';
import { TaskflowBuilderProvider, TaskflowWizardStep, useTaskflowBuilder } from './taskflowBuilderContext';
import { LibraryStep } from './steps/LibraryStep';
import { NameScopeStep } from './steps/NameScopeStep';
import { TaskListStep } from './steps/TaskListStep';
import { PublishStep } from './steps/PublishStep';

const STEP_ORDER: TaskflowWizardStep[] = ['library', 'nameScope', 'taskList', 'publish'];

const TaskflowBuilderContent: React.FC = () => {
    const { state, activeTaskflow, dispatch } = useTaskflowBuilder();

    const goToStep = (step: TaskflowWizardStep) => {
        if (step === 'library') {
            dispatch({ type: 'SET_STEP', step: 'library' });
            return;
        }
        if (!activeTaskflow) {
            return;
        }
        dispatch({ type: 'SET_STEP', step });
    };

    const currentIndex = STEP_ORDER.indexOf(state.step);
    const onBack = () => goToStep(STEP_ORDER[Math.max(0, currentIndex - 1)]);
    const onNext = () => goToStep(STEP_ORDER[Math.min(STEP_ORDER.length - 1, currentIndex + 1)]);

    const nextDisabled = state.step === 'library'
        || state.step === 'publish'
        || (state.step === 'nameScope' && !(activeTaskflow?.name ?? '').trim())
        || (state.step === 'taskList' && (activeTaskflow?.taskOrder.length ?? 0) === 0);

    return (
        <WizardFrame
            currentStep={state.step}
            onStepClick={goToStep}
            onBack={onBack}
            onNext={onNext}
            backDisabled={state.step === 'library'}
            nextDisabled={nextDisabled}
            nextLabel={state.step === 'publish' ? 'Done' : 'Next'}
            footerCaption={`Step ${currentIndex + 1} of ${STEP_ORDER.length}`}
        >
            {state.step === 'library' && <LibraryStep />}
            {state.step === 'nameScope' && <NameScopeStep />}
            {state.step === 'taskList' && <TaskListStep />}
            {state.step === 'publish' && <PublishStep />}
        </WizardFrame>
    );
};

export const TaskflowBuilderPage: React.FC<RouterProps> = (props) => {
    const onBackToConfiguration = () => props.history.push({ pathname: '/configurationDashboard' });

    return (
        <PageContentLayout
            pageHeader={{
                icon: <CallSplitIcon fontSize="small" />,
                title: 'Taskflow',
                subtitle: 'Build a guided task sequence for a matter category or type',
                onBack: onBackToConfiguration,
            }}
            hideToolbar={true}
        >
            <Box p={3} display="flex" flexDirection="column" flex={1} minHeight={0}>
                <TaskflowBuilderProvider>
                    <TaskflowBuilderContent />
                </TaskflowBuilderProvider>
            </Box>
        </PageContentLayout>
    );
};
